import TYPES from '../constants/action-types';

export const init = () => {
  // currently there is nothing to initialize on page load; keep this method
  // to avoid spontaneous appearing init procedures in different places
  return {
    type: TYPES.INIT.SUCCESS
  }
};
